'use client';

import { Provider } from 'jotai';

import React from 'react';

function StorageProviders({ children }: React.PropsWithChildren) {
    return (
    <Provider>
      {children}
    </Provider>
    );
}

export default StorageProviders;
